export default {
  header: 'Stroom',
};
